import { Text } from '$components'
import { useFormContext } from 'react-hook-form'
import { Input, CreateAppointmentSchema } from '.'
import { AvailableSlots as AvailableSlotsComponent } from '$components'

type AvailableSlotsProps = {
  personIds: number[]
}

export function AvailableSlots({ personIds }: AvailableSlotsProps) {
  const { watch, setValue } = useFormContext<CreateAppointmentSchema>()
  const services = watch(Input.Services)
  const date = watch(Input.Date)
  const pet = watch(Input.Pet)
  const createNewPet = watch(Input._NewPet)
  const newPetBreed = watch(Input.NewPetBreed)
  const selectedSlot = watch(Input.Slot)

  if (!services) {
    return (
      <div className="p-stack-section bg-surface-muted rounded-surface flex items-center justify-center">
        <Text
          type="s"
          weight="light"
        >
          Select a service to see available slots
        </Text>
      </div>
    )
  }

  const duration = watch(Input.Duration)

  if (!duration || !date) {
    return null
  }

  return (
    <AvailableSlotsComponent
      duration={duration}
      date={date}
      personIds={personIds}
      enabled={!!services && !!date && (!!pet || (createNewPet && !!newPetBreed))}
      selectedSlotId={selectedSlot?.id}
      onSlotSelect={(slot) => setValue(Input.Slot, slot)}
      emptyStateMessage="No slots available"
    />
  )
}
